var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerpotBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.985,
    height: 106.663,
    viewBox: "0 0 153.985 106.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42249",
    "data-name": "Path 42249",
    d: "M76.992,0a76.992,76.992,0,0,1,76.992,76.992c0,42.522-31.59,26.848-74.112,26.848S0,119.514,0,76.992A76.992,76.992,0,0,1,76.992,0Z",
    fill: "#fff",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerpotBg);
export default __webpack_public_path__ + "static/media/FlowerpotBg.751ee6d8751a046c1a67a3650be94fe7.svg";
export { ForwardRef as ReactComponent };